import MBottomBar from './MBottomBar.vue';

MBottomBar.install = (app) => {
  app.component('MBottomBar', MBottomBar);
};

export { MBottomBar };
